import React, { useEffect, useState, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { content, images } from '../mockData';

const ContactSection = () => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const sectionRef = useRef(null);
  const contactContent = content[language].contact;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {/* Contact Section */}
      <section 
        id="contact" 
        ref={sectionRef}
        style={{
          position: 'relative',
          minHeight: '80vh',
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden'
        }}
      >
        {/* Parallax Background */}
        <div 
          className="parallax-bg"
          style={{
            transform: `translateY(${(scrollY - (sectionRef.current?.offsetTop || 0)) * 0.4}px)`
          }}
        >
          <img src={images.contact} alt="Contact" />
        </div>
        <div className="parallax-overlay" style={{ background: 'rgba(0,0,0,0.55)' }} />

        {/* Content */}
        <div className="parallax-content" style={{ width: '100%', padding: '140px 6%' }}>
          <div className="container-narrow text-center">
            <div className={`fade-in-up ${isVisible ? 'visible' : ''}`}>
              <h2 style={{ color: '#ffffff', marginBottom: '32px' }}>
                {contactContent.title}
              </h2>
              <p 
                style={{ 
                  color: 'rgba(255,255,255,0.85)',
                  marginBottom: '48px',
                  fontSize: '1.0625rem'
                }}
              >
                {contactContent.note}
              </p>
              
              <div style={{ marginBottom: '32px' }}>
                <a 
                  href={`mailto:${contactContent.email}`}
                  style={{
                    fontFamily: 'Inter, sans-serif',
                    fontSize: '1.125rem',
                    color: '#ffffff',
                    textDecoration: 'none',
                    borderBottom: '1px solid rgba(255,255,255,0.4)',
                    paddingBottom: '4px',
                    transition: 'border-color 0.3s ease',
                    fontWeight: 400,
                    letterSpacing: '0.02em'
                  }}
                  onMouseEnter={(e) => e.target.style.borderColor = '#ffffff'}
                  onMouseLeave={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.4)'}
                >
                  {contactContent.email}
                </a>
              </div>

              {contactContent.phone && (
                <div style={{ marginBottom: '48px' }}>
                  <a 
                    href={`tel:${contactContent.phone}`}
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontSize: '1.125rem',
                      color: '#ffffff',
                      textDecoration: 'none',
                      borderBottom: '1px solid rgba(255,255,255,0.4)',
                      paddingBottom: '4px',
                      transition: 'border-color 0.3s ease',
                      fontWeight: 400,
                      letterSpacing: '0.02em'
                    }}
                    onMouseEnter={(e) => e.target.style.borderColor = '#ffffff'}
                    onMouseLeave={(e) => e.target.style.borderColor = 'rgba(255,255,255,0.4)'}
                  >
                    {contactContent.phone}
                  </a>
                </div>
              )}
              
              <p 
                style={{ 
                  color: 'rgba(255,255,255,0.6)',
                  marginTop: '48px',
                  fontSize: '0.875rem',
                  fontStyle: 'italic'
                }}
              >
                {contactContent.disclaimer}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <section className="section section-ivory" style={{ paddingTop: '80px', paddingBottom: '80px' }}>
        <div className="container-narrow text-center">
          {/* Logo */}
          <div style={{ marginBottom: '32px' }}>
            <img 
              src={images.logo} 
              alt="Tenuta Scerni" 
              style={{
                width: '90px',
                height: 'auto',
                opacity: 0.5
              }}
            />
          </div>
          
          <p style={{ fontSize: '0.875rem', color: 'var(--stone)', letterSpacing: '0.5px' }}>
            Tenuta Scerni © 2025
          </p>
        </div>
      </section>
    </>
  );
};

export default ContactSection;
